

export class AdminAccount {
  createPermissionsQuery(projectId: string){
    return {projectId}
  }
}